export default __webpack_public_path__ + "_/shared_modules/sprites/dist/sprite-background@2x-e70e082fd8f55cf72a30d39735a0f8fa.png";